var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M1.00589 8.3086C0.90228 5.97675 2.12493 1.25222 7.84443 1.0089C13.5639 0.765578 14.9938 5.57121 14.9938 8.00445C15.0974 10.0321 13.937 14.27 8.46614 15C7.42999 15 5.29554 14.5134 5.04687 12.5668V7.7003C5.2541 6.78784 6.1659 4.96291 8.15529 4.96291C10.1447 4.96291 10.8493 6.78784 10.9529 7.7003C11.0565 8.71415 10.642 10.8027 8.15529 11.046",
    stroke: "#FFD43B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListsIcon);
export default __webpack_public_path__ + "static/media/lists-icon.5eebe211b95ba4a0cd5b04d9096dec5f.svg";
export { ForwardRef as ReactComponent };